import { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { X } from 'lucide-react';
import { toast } from 'sonner';

const AuthModal = ({ onClose }) => {
  const [isLogin, setIsLogin] = useState(true);
  const [usernameOrEmail, setUsernameOrEmail] = useState('');
  const [email, setEmail] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, register } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (isLogin) {
        await login(usernameOrEmail, password);
        toast.success('¡Bienvenido de nuevo!');
      } else {
        await register(email, username, password, name);
        toast.success('¡Cuenta creada exitosamente!');
      }
      onClose();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al autenticar');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="glass rounded-2xl p-8 max-w-md w-full relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-2 hover:bg-white/30 rounded-full"
          data-testid="close-auth-modal"
        >
          <X size={20} />
        </button>

        <h2 className="text-3xl font-bold mb-6 text-center">
          {isLogin ? 'Iniciar Sesión' : 'Crear Cuenta'}
        </h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          {!isLogin && (
            <>
              <div>
                <Label htmlFor="name">Nombre</Label>
                <Input
                  id="name"
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required={!isLogin}
                  className="mt-1"
                  placeholder="Tu nombre"
                  data-testid="name-input"
                />
              </div>
              
              <div>
                <Label htmlFor="username">Nombre de Usuario</Label>
                <Input
                  id="username"
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required={!isLogin}
                  className="mt-1"
                  placeholder="usuario123"
                  data-testid="username-input"
                />
              </div>
            </>
          )}

          <div>
            <Label htmlFor={isLogin ? "usernameOrEmail" : "email"}>
              {isLogin ? "Usuario o Email" : "Email"}
            </Label>
            <Input
              id={isLogin ? "usernameOrEmail" : "email"}
              type={isLogin ? "text" : "email"}
              value={isLogin ? usernameOrEmail : email}
              onChange={(e) => isLogin ? setUsernameOrEmail(e.target.value) : setEmail(e.target.value)}
              required
              className="mt-1"
              placeholder={isLogin ? "usuario o tu@email.com" : "tu@email.com"}
              data-testid={isLogin ? "username-or-email-input" : "email-input"}
            />
          </div>

          <div>
            <Label htmlFor="password">Contraseña</Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="mt-1"
              placeholder="••••••••"
              data-testid="password-input"
            />
          </div>

          <Button
            type="submit"
            disabled={loading}
            className="w-full bg-[#77C9D4] hover:bg-[#5AB4C1] !text-white dark:!text-black rounded-full py-6 text-lg font-semibold"
            data-testid="auth-submit-button"
          >
            {loading ? 'Procesando...' : isLogin ? 'Iniciar Sesión' : 'Crear Cuenta'}
          </Button>
        </form>

        <div className="mt-6 text-center">
          <button
            onClick={() => setIsLogin(!isLogin)}
            className="text-[#77C9D4] hover:underline font-medium"
            data-testid="toggle-auth-mode"
          >
            {isLogin ? '¿No tienes cuenta? Regístrate' : '¿Ya tienes cuenta? Inicia sesión'}
          </button>
        </div>

        <div className="mt-4 text-center text-sm text-gray-600">
          <p>También puedes usar la app sin cuenta</p>
        </div>
      </div>
    </div>
  );
};

export default AuthModal;